var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 12,
    fill: "none",
    viewBox: "0 0 14 12",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m6.282 2.62-3.81 3.81c-1.173 1.172-1.76 2.345-.294 3.81 1.466 1.466 2.639.88 3.811-.293l6.156-6.155c.88-.88.586-1.76 0-2.345-.586-.587-1.466-.88-2.345 0L3.644 7.602c-.586.587-.586 1.173-.293 1.466s.88.293 1.466-.293l5.57-5.57"
  })));
});
const SvgAttachmentsmall = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAttachmentsmall);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxNCAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTYuMjgyMjIgMi42MTkxNEwyLjQ3MTUxIDYuNDI5ODZDMS4yOTg5OCA3LjYwMjM5IDAuNzEyNzE3IDguNzc0OTEgMi4xNzgzOCAxMC4yNDA2QzMuNjQ0MDQgMTEuNzA2MiA0LjgxNjU2IDExLjEyIDUuOTg5MDkgOS45NDc0NEM2Ljg2ODQ5IDkuMDY4MDUgMTAuOTcyMyA0Ljk2NDIgMTIuMTQ0OSAzLjc5MTY3QzEzLjAyNDMgMi45MTIyOCAxMi43MzExIDIuMDMyODggMTIuMTQ0OSAxLjQ0NjYyQzExLjU1ODYgMC44NjAzNTMgMTAuNjc5MiAwLjU2NzIyMiA5Ljc5OTggMS40NDY2MkM4LjkyMDQxIDIuMzI2MDEgNC4yMzAzIDcuMDE2MTIgMy42NDQwNCA3LjYwMjM5QzMuMDU3NzcgOC4xODg2NSAzLjA1Nzc3IDguNzc0OTEgMy4zNTA5IDkuMDY4MDVDMy42NDQwNCA5LjM2MTE4IDQuMjMwMyA5LjM2MTE4IDQuODE2NTYgOC43NzQ5MUM1LjI4NTU3IDguMzA1OSA5LjAxODEyIDQuNTczMzYgMTAuMzg2MSAzLjIwNTQxIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";